export const CommonGroupCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Gruppi',
    path: '/sistema/gruppi',
  },
];
